import { conversationKey } from "./conversationIdentity.mjs";

export function maskReadPushEvents(events, cutoffs) {
  return (events || []).map(event => {
    const key = conversationKey(event.storeId, event.phone);
    const cutoff = cutoffs[key];
    return !event.firstViewedAt && cutoff && Date.parse(event.receivedAt) <= Date.parse(cutoff)
      ? { ...event, firstViewedAt:cutoff } : event;
  });
}

export function prospectUnreadCount(messages, readAt, pushCount = 0) {
  const rows = Object.values(messages || {}).filter(Boolean);
  const latestReply = rows.filter(message => message.remetente === "consultor"
    && ["sent","delivered","read"].includes(message.status))
    .reduce((latest, message) => Math.max(latest, Date.parse(message.timestamp) || 0), 0);
  const cutoff = Math.max(Date.parse(readAt) || 0, latestReply);
  const unread = rows.filter(message => message.remetente === "cliente"
    && Date.parse(message.timestamp) > cutoff).length;
  return Math.max(unread, Number(pushCount) || 0);
}
